import { Flex, Table, Text } from '@mantine/core';
import { IconChevronDown, IconChevronUp } from '@tabler/icons-react';

type SortableHeaderProps = {
  column: string;
  label: string;
  sortBy: string;
  sortDirection: string;
  onSort: (column: string) => void;
  isSortable: boolean;
};

const SortableHeader = ({
  column,
  label,
  sortBy,
  sortDirection,
  onSort,
  isSortable
}: SortableHeaderProps) => {
  const isActive = sortBy === column;

  return (
    <Table.Th
      py={'xs'}
      onClick={isSortable ? () => onSort(column) : undefined}
      style={{ cursor: isSortable ? 'pointer' : 'default', userSelect: 'none' }}>
      <Flex align="center" gap="xs">
        <Text size={'sm'} fw={'600'} c={'gray.8'}>
          {label}
        </Text>
        {isSortable &&
          isActive &&
          (sortDirection === 'ASC' ? <IconChevronUp size={16} /> : <IconChevronDown size={16} />)}
      </Flex>
    </Table.Th>
  );
};

export default SortableHeader;
